var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"spinner-wrap"},[_c('div',{staticClass:"dot"}),_c('div',{staticClass:"spinner"},_vm._l((12),function(n){return _c('span',{key:'n'+n,staticClass:"spike"})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }